(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discreet-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("cart-discreet-shipping")) {
    class CartDiscreetShipping extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector("[data-discreet-shipping-input]");
        this.field = this.querySelector("[data-discreet-shipping-field]");
        this.status = this.querySelector("[data-discreet-shipping-status]");

        if (!this.checkbox || !this.field) return;

        if (
          CartDiscreetShipping.instances.size === 0 &&
          !CartDiscreetShipping.requestInFlight
        ) {
          CartDiscreetShipping.savedValue = this.checkbox.checked;
          CartDiscreetShipping.desiredValue = this.checkbox.checked;
        }

        CartDiscreetShipping.instances.add(this);
        CartDiscreetShipping.sync();
        this.checkbox.addEventListener("change", this.handleChange);
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener("change", this.handleChange);
        CartDiscreetShipping.instances.delete(this);
      }

      handleChange = () => {
        CartDiscreetShipping.desiredValue = this.checkbox.checked;
        CartDiscreetShipping.sync();
        CartDiscreetShipping.setError("");
        CartDiscreetShipping.persist();
      };

      static sync() {
        this.instances.forEach((instance) => {
          instance.checkbox.checked = this.desiredValue;
          instance.field.value = this.desiredValue ? "Sí" : "";
        });
      }

      static setError(message) {
        this.instances.forEach((instance) => {
          if (instance.status) instance.status.textContent = message;
        });
      }

      static setBusy(isBusy) {
        this.instances.forEach((instance) => {
          instance.toggleAttribute("aria-busy", isBusy);
        });
      }

      static async persist() {
        if (
          this.requestInFlight ||
          this.desiredValue === this.savedValue
        ) {
          return;
        }

        this.requestInFlight = true;
        this.setBusy(true);
        const submittedValue = this.desiredValue;
        const config =
          typeof fetchConfig === "function"
            ? fetchConfig()
            : {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              };

        try {
          const response = await fetch(window.routes?.cart_update_url || "/cart/update.js", {
            ...config,
            keepalive: true,
            body: JSON.stringify({
              attributes: {
                envio_discreto: submittedValue ? "Sí" : "",
              },
            }),
          });

          if (!response.ok) throw new Error("Cart attribute update failed");
          this.savedValue = submittedValue;
        } catch {
          if (this.desiredValue === submittedValue) {
            this.desiredValue = this.savedValue;
            this.sync();
            this.setError(
              this.instances.values().next().value?.dataset.errorMessage || "",
            );
          }
        } finally {
          this.requestInFlight = false;
          this.setBusy(false);

          if (this.desiredValue !== this.savedValue) {
            this.persist();
          }
        }
      }
    }

    CartDiscreetShipping.instances = new Set();
    CartDiscreetShipping.savedValue = undefined;
    CartDiscreetShipping.desiredValue = undefined;
    CartDiscreetShipping.requestInFlight = false;
    customElements.define("cart-discreet-shipping", CartDiscreetShipping);
  }
  } catch(e) { console.error(e); }
})();

})();
